import { createApp } from './main'
import { createHead } from '@unhead/vue'

const { app, router } = createApp()
const clientHead = createHead()
app.use(clientHead)
router.isReady().then(() => {
  // Mount the app
  app.mount('#app')
})
